import { render, staticRenderFns } from "./BaseBtnMenu.vue?vue&type=template&id=60c0292f&scoped=true&lang=pug"
import script from "./BaseBtnMenu.vue?vue&type=script&lang=js"
export * from "./BaseBtnMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnMenu.vue?vue&type=style&index=0&id=60c0292f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0292f",
  null
  
)

export default component.exports